import { ecommerceTranslations } from './languages';
import en from './languages/en';
import it from './languages/it';
import nl from './languages/nl';

export type Language = 'en' | 'it' | 'nl' | 'fr' | 'es' | 'de' | 'tr';

// Define the structure based on the actual en.ts file
export type Translations = typeof en;

export const translations: Record<Language, Translations> = {
  en: en as any,
  it: it as any,
  nl: nl as any,
  // Fallback to English for languages not yet implemented
  fr: en as any,
  es: en as any,
  de: en as any,
  tr: en as any,
};
